import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';

class IssueFetchError extends PureComponent {
  render() {
    const { error } = this.props;
    if (!error) {
      return null;
    }

    const genericErrorMsg = T.translate('global.genericError');
    return (
      <div className="isui-error">{genericErrorMsg}</div>
    );
  }
}

IssueFetchError.displayName = 'IssueFetchError';
IssueFetchError.propTypes = {
  error: PropTypes.bool,
};

export default IssueFetchError;
